const completionMarkerPrefix = 'mastery:bank-completed:';

export function bankPartProgress(
  questionIds: string[],
  responses: Record<string, string>,
  submittedResponses: Record<string, string>,
) {
  const answered = questionIds.filter((id) => responses[id]?.trim()).length;
  const submitted =
    answered > 0 &&
    questionIds.every(
      (id) =>
        Object.prototype.hasOwnProperty.call(submittedResponses, id) &&
        submittedResponses[id] === (responses[id] || ''),
    );
  return {
    state: submitted ? 'completed' : answered > 0 ? 'in-progress' : 'not-started',
    answered,
    total: questionIds.length,
  } as const;
}

export function bankPartSelectionSearch(search: string) {
  const current = new URLSearchParams(search);
  const next = new URLSearchParams({ view: 'parts' });
  const test = current.get('test');
  if (test) next.set('test', test);
  return `?${next.toString()}`;
}

export function bankCompletionMarkerKey(
  scope: string,
  exam: string,
  book: string,
  section: string,
) {
  return `${completionMarkerPrefix}${scope}:${exam}:${book}:${section}`;
}

/** Remove only submitted markers; answer drafts use a separate storage key. */
export function clearBankCompletionMarkers(scope: string) {
  try {
    const prefix = `${completionMarkerPrefix}${scope}:`;
    for (const key of Object.keys(localStorage)) {
      if (key.startsWith(prefix)) localStorage.removeItem(key);
    }
  } catch {
    // Storage is optional when the browser blocks it.
  }
}
